import PDFPageEditorOptInPanel from 'PDFPageEditorOptInPanel';

window.PDFPageEditorOptInPanel = PDFPageEditorOptInPanel;

// Import PDFJS
window.pdfjsDistBuildPdf = require('pdfjs-dist');

// Load in our PDFJS Worker, convert it to URL, assign to PDFJS obj
// Pulled from https://github.com/mozilla/pdf.js/issues/7612 @wojtekmaj
const pdfjsWorker = require('pdfjs-dist/build/pdf.worker.min');

const pdfjsWorkerBlob = new Blob([pdfjsWorker]);
const pdfjsWorkerBlobURL = URL.createObjectURL(pdfjsWorkerBlob);
window.pdfjsDistBuildPdf.PDFJS.workerSrc = pdfjsWorkerBlobURL;



// WEBPACK FOOTER //
// ./src-assets/js/edit-pages-opt-in.js